module.exports = __webpack_public_path__ + "img/game_tiyu_paiqiu.ddcef56e.png";